module.exports = __webpack_public_path__ + "img/3-4.60a23a09.svg";